import Carousel, { CarouselItem } from "./Carousel";

import HeaderImage from "../assets/img/header-img.png";
import SchoolOne from "../assets/img/schools/school_01.jpg";
import SchoolTwo from "../assets/img/schools/school_02.jpg";
import SchoolThree from "../assets/img/schools/school_03.jpg";
import SchoolFour from "../assets/img/schools/school_04.jpg";
import SchoolFive from "../assets/img/schools/school_05.jpg";



const Slide = ({ number, ImageSrc, width, height, textHeader, textBody, textFooter }) => (
    <div  className = "head-text">
      <div sx={{width:'20%'}} >Shule yet</div>
      <div  sx={{width:'60%'}} >
      <img src={ImageSrc} sx={{ width: width, height: height}} />
      <center>
      <div class='text-on-image'>
            
            <div class='text-on-image-div'>

            <h4>{textHeader}</h4>
            <p>{textFooter}</p>
             <p>{textBody}</p>
             
            </div>
            
             
          </div>
      </center>
      </div>
      <div sx={{width:'20%'}} ></div>
      
      
    </div>
  );

{/****
const Slide = ({ number, ImageSrc }) => (
    <div>
      <img src={`https://via.placeholder.com/328x164.png?text=Slide ${number}`} />
      {number}
    </div>
  );
***/}
export default function CarouselX() {
    return (
<Carousel>
<CarouselItem width={780} height={580}>
  <Slide number={1} ImageSrc={SchoolOne} width={780} height={580}
  textHeader='ABC Secondary School'
  textBody='Telephone: +255717000000'  
  textFooter='Dar-es-salaam, Kisutu, opposite na Bibi Titi Road'
  />
</CarouselItem>
<CarouselItem>
  <Slide number={2} ImageSrc={SchoolTwo}  width={780} height={580}
  textHeader='Morogoro Secondary School'
  textFooter='Morogoro, Mji mwema'
  textBody='Telephone: +255717000000'  
  />
</CarouselItem>
<CarouselItem>
  <Slide number={3} ImageSrc={SchoolThree}  width={780} height={580}
  textHeader='Arusha Secondary School'
  textFooter='Aarusha, Makao mapya, '
  textBody='Telephone: +255717000000'  
  />
</CarouselItem>
<CarouselItem>
  <Slide number={4} ImageSrc={SchoolFour}  width={780} height={580}
  textHeader='Kilwa Secondary School'
  textFooter='Kilwa kivinje'
  textBody='Telephone: +255717000000'  
  />
</CarouselItem>
<CarouselItem>
  <Slide number={5} ImageSrc={SchoolFive}  width={780} height={580}
  textHeader='Fortune Secondary School'
  textBody='Telephone: +255717000000'  
  textFooter='Dar-es-salaam, Kinyerezi'
  />
</CarouselItem>

</Carousel>
    )
}